import { compose } from 'recompose';

import MetaFilter from './MetaFilter';

const enhance = compose();

export default enhance(MetaFilter);
